// src/components/AboutUs.js

import React, { useEffect } from 'react';
import './AboutUs.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import AOS from 'aos';
import { useTranslation } from 'react-i18next';

const AboutUs = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in ms
      once: true, // Whether animation should happen only once
    });
  }, []);



  return (
    <div className="about-us-container">
      {/* Who Are We Section */}
      <section className="about-us-section who-are-we-section" data-aos="fade-up">
        <h2 className="section-title">{t('about.production_facility')}</h2>
        <div className="section-content">
          <iframe
            title="Who Are We?"
            src="https://www.youtube.com/embed/h3eLcrRt9ps"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            frameBorder="0"
            allowFullScreen
            loading="lazy"
          ></iframe>
        </div>
      </section>

      {/* Our Mission Section */}
      <section className="about-us-section our-mission-section" data-aos="fade-right">
        <div className="mission-content">
          <h2 className="section-title">{t('about.mission.title')}</h2>
          <ul className="mission-list">
            {t('about.mission.points', { returnObjects: true }).map((point, index) => (
              <li key={index} data-aos="fade-up" data-aos-delay={100 * (index + 1)}>
                <FontAwesomeIcon icon={faCheckCircle} className="icon" />
                {point}
              </li>
            ))}
          </ul>
        </div>
        <div className="mission-image-container">
          <img src="/images/mission-image.jpg" alt="Mission Image" loading="lazy" />
        </div>
      </section>

      {/* Our Vision Section */}
      <section className="about-us-section our-vision-section" data-aos="fade-left">
        {/* Image moved to the left */}
        <div className="vision-image-container">
          <img src="/images/vision-image.jpg" alt="Vision Image" loading="lazy" />
        </div>
        <div className="vision-content">
          <h2 className="section-title">{t('about.vision.title')}</h2>
          <ul className="vision-list">
            {t('about.vision.points', { returnObjects: true }).map((point, index) => (
              <li key={index} data-aos="fade-up" data-aos-delay={100 * (index + 1)}>
                <FontAwesomeIcon icon={faCheckCircle} className="icon" />
                {point}
              </li>
            ))}
          </ul>
        </div>
      </section>


    </div>
  );
};

export default AboutUs;
